<template>
  <CompanyList />
</template>

<script>
import CompanyList from '@/components/Admin/CompanyList.vue';

export default {
  components: {
    CompanyList
  },
  data() {
    return {
    };
  },
  computed: {
  },
  created() {
  },
  methods: {
  }
};
</script>
